
@switch (col.editableConfig?.type) {
  @case ('text') {
    <p-cellEditor>
      <ng-template pTemplate="input">
        <app-yabi-input [(ngModelValue)]="row[col.name]" [id]="col.name + index"
          (onChange)="col.editableConfig?.onInputCallback ? col.editableConfig?.onInputCallback(tableConfig.columnsConfig,row,$event):$event.preventDefault"
          [class]="col.class" [editable]="true" type="text" [disabled]="col.editableConfig?.disabled"
          [placeholder]="col.label" [ngModelInvalidInput]="col.editableConfig?.ngModelInvalidInput" [form]="form"
        [formControlNameInput]="formControlNameInput"></app-yabi-input>
      </ng-template>
      <ng-template pTemplate="output">
        @if (row[col.name] || !col.editableConfig?.outputEmptyValue) {
          <app-yabi-input [(ngModelValue)]="row[col.name]" [editable]="true" [form]="form" type="text"
            [class]="col.class" [formControlNameInput]="formControlNameInput"
          [id]="col.name + index"></app-yabi-input>
        } @else {
          {{col.editableConfig?.outputEmptyValue}}
        }
      </ng-template>
    </p-cellEditor>
  }
  @case ('number') {
    <div>
      <p-cellEditor>
        <ng-template pTemplate="input">
          <app-yabi-input [(ngModelValue)]="row[col.name]" [id]="col.name + index"
            (onChange)="col.editableConfig?.onInputCallback ? col.editableConfig?.onInputCallback(tableConfig.columnsConfig,row,$event):$event.preventDefault"
            [class]="col.class" [editable]="true" type="number" [disabled]="col.editableConfig?.disabled"
            [placeholder]="col.label" [ngModelInvalidInput]="col.editableConfig?.ngModelInvalidInput"
            [numberInputDecimal]="col.editableConfig?.numberInputDecimal" [form]="form"
          [formControlNameInput]="formControlNameInput"></app-yabi-input>
        </ng-template>
        <ng-template pTemplate="output">
          @if (row[col.name] || !col.editableConfig?.outputEmptyValue) {
            <app-yabi-input [(ngModelValue)]="row[col.name]" [editable]="true" [form]="form" type="number"
              [class]="col.class" [formControlNameInput]="formControlNameInput"
              [numberInputDecimal]="col.editableConfig?.numberInputDecimal"
            [id]="col.name + index"></app-yabi-input>
          } @else {
            {{col.editableConfig?.outputEmptyValue}}
          }
        </ng-template>
      </p-cellEditor>
    </div>
  }
  @case ('dropdown') {
    <div>
      <p-cellEditor>
        <ng-template pTemplate="input">
          <app-yabi-input [(ngModelValue)]="row[col.name]" type="dropdown"
            (onChange)="col.editableConfig?.onInputCallback ? col.editableConfig?.onInputCallback(tableConfig.columnsConfig,row,$event):$event.preventDefault"
            [id]="col.name + index" [disabled]="col.editableConfig?.disabled" [listConfig]="listConfigData"
            [editable]="true" [ngModelInvalidInput]="col.editableConfig?.ngModelInvalidInput" [form]="form"
            [labelCallbackFunction]="col.valueFromCallback" [placeholder]="col.label"
          [formControlNameInput]="formControlNameInput"></app-yabi-input>
        </ng-template>
        <ng-template pTemplate="output">
          @if (row[col.name] || !col.editableConfig?.outputEmptyValue) {
            <app-yabi-input type="dropdown" [(ngModelValue)]="row[col.name]" [editable]="true"
              [labelCallbackFunction]="col.valueFromCallback" [id]="col.name + index"
              [listConfig]="listConfigData" [form]="form" [placeholder]="col.label"
            [formControlNameInput]="formControlNameInput"></app-yabi-input>
          } @else {
            {{col.editableConfig?.outputEmptyValue}}
          }
        </ng-template>
      </p-cellEditor>
    </div>
  }
  @case ('daysRange') {
    <div>
      <p-cellEditor>
        <ng-template pTemplate="input">
          <app-yabi-input [(ngModelValue)]="row[col.name]"
            (onChange)="col.editableConfig?.onInputCallback ? col.editableConfig?.onInputCallback(tableConfig.columnsConfig,row,$event):$event.preventDefault"
            [(ngModelSecondValue)]=" row[col.editableConfig?.rangeColumnName]" type="daysRange"
            [id]="col.name + index" [disabled]="col.editableConfig?.disabled" [editable]="true"
            [ngModelInvalidInput]="col.editableConfig?.ngModelInvalidInput"
            [listConfig]="col.editableConfig?.listConfig" [form]="form"
            [formControlNameInput]="formControlNameInput"
          [rangeFormControlNameInput]="col.editableConfig?.rangeColumnName"></app-yabi-input>
        </ng-template>
        <ng-template pTemplate="output">
          @if (row[col.name]  || !col.editableConfig?.outputEmptyValue) {
            <!--      <span
            *ngIf="!form && row[col.editableConfig?.rangeColumnName] || row[col.name]">{{col.editableConfig?.listConfig.data[row[col.name]
            - 1][col.editableConfig?.listConfig.optionLabel]}}
            -
            {{col.editableConfig?.listConfig.data[row[col.editableConfig?.rangeColumnName]-
          1][col.editableConfig?.listConfig.optionLabel]}}</span> -->
          <app-yabi-input [(ngModelValue)]="row[col.name]"
            (onChange)="col.editableConfig?.onInputCallback ? col.editableConfig?.onInputCallback(tableConfig.columnsConfig,row,$event):$event.preventDefault"
            [(ngModelSecondValue)]=" row[col.editableConfig?.rangeColumnName]" type="daysRange"
            [id]="col.name + index" [disabled]="col.editableConfig?.disabled" [editable]="true"
            [ngModelInvalidInput]="col.editableConfig?.ngModelInvalidInput"
            [listConfig]="col.editableConfig?.listConfig" [form]="form"
            [formControlNameInput]="formControlNameInput"
          [rangeFormControlNameInput]="col.editableConfig?.rangeColumnName"></app-yabi-input>
        } @else {
          {{col.editableConfig?.outputEmptyValue}}
        }
      </ng-template>
    </p-cellEditor>
  </div>
}
@case ('timeRange') {
  <div>
    <p-cellEditor>
      <ng-template pTemplate="input">
        <app-yabi-input [(ngModelValue)]="row[col.name]" [row]="row" [class]="col.editableConfig?.class"
          (onChange)="col.editableConfig?.onInputCallback ? col.editableConfig?.onInputCallback(tableConfig.columnsConfig,row,$event):$event?.preventDefault"
          [(ngModelSecondValue)]="row[col.editableConfig?.rangeColumnName]" type="timeRange"
          [id]="col.name + index" [disabled]="col.editableConfig?.disabled" [form]="form" [editable]="true"
          [formControlNameInput]="formControlNameInput"
        [rangeFormControlNameInput]="col.editableConfig?.rangeColumnName"></app-yabi-input>
      </ng-template>
      <ng-template pTemplate="output">
        @if (row[col.name] || !col.editableConfig?.outputEmptyValue) {
          <app-yabi-input [(ngModelValue)]="row[col.name]" [row]="row" [class]="col.editableConfig?.class"
            [(ngModelSecondValue)]="row[col.editableConfig?.rangeColumnName]" type="timeRange"
            [id]="col.name + index" [editable]="true" [form]="form"
            [formControlNameInput]="formControlNameInput"
          [rangeFormControlNameInput]="col.editableConfig?.rangeColumnName"></app-yabi-input>
        } @else {
          {{col.editableConfig?.outputEmptyValue}}
        }
      </ng-template>
    </p-cellEditor>
  </div>
}
@case ('dateTime') {
  <div>
    <p-cellEditor>
      <ng-template pTemplate="input">
        <app-yabi-input [(ngModelValue)]="row[col.name]" [row]="row" [type]="col.editableConfig?.type"
          [id]="col.name + index" [editable]="true" [disabled]="col.editableConfig?.disabled"
          [wrapperClass]="col.class" [class]="col.editableConfig?.class"
          [ngModelInvalidInput]="col.editableConfig?.ngModelInvalidInput"
          [dateTimeConfig]="col.editableConfig?.dateTimeConfig" [form]="form"
        [formControlNameInput]="formControlNameInput"></app-yabi-input>
      </ng-template>
      <ng-template pTemplate="output">
        @if (row[col.name]  || !col.editableConfig?.outputEmptyValue) {
          <app-yabi-input [(ngModelValue)]="row[col.name]" [row]="row" [class]="col.editableConfig?.class"
            [type]="col.editableConfig?.type" [id]="col.name + index" [editable]="form ? true : false"
            [dateTimeConfig]="col.editableConfig?.dateTimeConfig" [form]="form"
          [formControlNameInput]="formControlNameInput"></app-yabi-input>
        } @else {
          {{col.editableConfig?.outputEmptyValue}}
        }
      </ng-template>
    </p-cellEditor>
  </div>
}
@case ('date') {
  <div>
    <p-cellEditor>
      <ng-template pTemplate="input">
        <app-yabi-input [(ngModelValue)]="row[col.name]" [row]="row" [class]="col.class"
          [type]="col.editableConfig?.type" [id]="col.name + index" [editable]="true"
          [disabled]="col.editableConfig?.disabled"
          [ngModelInvalidInput]="col.editableConfig?.ngModelInvalidInput"
          [dateTimeConfig]="col.editableConfig?.dateTimeConfig" [form]="form"
        [formControlNameInput]="formControlNameInput"></app-yabi-input>
      </ng-template>
      <ng-template pTemplate="output">
        @if (row[col.name]  || !col.editableConfig?.outputEmptyValue) {
          <app-yabi-input [(ngModelValue)]="row[col.name]" [row]="row" [class]="col.class"
            [type]="col.editableConfig?.type" [id]="col.name + index" [editable]="form ? true : false"
          [dateTimeConfig]="col.editableConfig?.dateTimeConfig"></app-yabi-input>
        } @else {
          {{col.editableConfig?.outputEmptyValue}}
        }
      </ng-template>
    </p-cellEditor>
  </div>
}
@case ('checkbox') {
  <div>
    @if (!col.editableConfig?.disabled) {
      <p-cellEditor>
        <ng-template pTemplate="input">
          <app-yabi-input [ngModelValue]="row[col.name]" [row]="row" [class]="col.editableConfig?.class"
            type="checkbox" [id]="col.name + index" [editable]="true" [readonly]="col.editableConfig?.disabled"
            (onChange)="col.editableConfig?.onInputCallback ? col.editableConfig?.onInputCallback(tableConfig.columnsConfig,row,$event):$event.preventDefault"
          [form]="form" [formControlNameInput]="formControlNameInput"></app-yabi-input>
        </ng-template>
        <ng-template pTemplate="output">
          <ng-container>
            <app-yabi-input [(ngModelValue)]="row[col.name]" [row]="row" [class]="col.editableConfig?.class"
              type="checkbox" [id]="col.name + index" [editable]="true"
              [readonly]="col.editableConfig?.disabled"
            (onChange)="col.editableConfig?.onInputCallback ? col.editableConfig?.onInputCallback(tableConfig.columnsConfig,row,$event):$event.preventDefault"></app-yabi-input>
          </ng-container>
        </ng-template>
      </p-cellEditor>
    }
    @if (col.editableConfig?.disabled) {
      <app-yabi-input [ngModelValue]="row[col.name]" [row]="row"
        [class]="col.editableConfig?.class" type="checkbox" [id]="col.name + index" [editable]="true"
        [readonly]="true" onclick='return false;'
      (onChange)="col.editableConfig?.onInputCallback ? col.editableConfig?.onInputCallback(tableConfig.columnsConfig,row,$event):$event.preventDefault"></app-yabi-input>
    }
  </div>
}
}
